import { css } from 'styled-components';
export const datepickerHeaderWrapper = css `
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 1.4rem;
`;
export const datepickerHeaderButton = css `
  appearance: none;
  -webkit-appearance: none;
  background-color: transparent;
  padding: 0;
  flex: 0 0 3.4rem;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border: none;
  height: 3.4rem;
  width: 3.4rem;

  span {
    display: none;
  }
`;
export const datepickerHeaderHeading = css `
  margin: 0 1rem;
  flex-basis: 14rem;
  position: relative;
`;
